export const RECENT_SEARCH_LIMIT = 3